export default __webpack_public_path__ + "static/flowersmcewan-logo-white-8215691e6073269cdb748f96ce0a5534.svg";